// extracted by mini-css-extract-plugin
export default {"buttonContainer":"hEL5U","alignToEdge":"lLrTy","buttonIcon":"cKTvn","buttonCaption":"s4y4X","buttonSpacer":"_4-Wtb"};